import { Nullable } from 'cng-common/models/utils'

interface ICalculateWeightedAverageSobParams {
  revenue: Nullable<number>
  estimatedRevenue: Nullable<number>
}

export const calculateWeightedAverageSob = ({
  revenue,
  estimatedRevenue,
}: ICalculateWeightedAverageSobParams) => {
  const hasRevenue = !!revenue
  const hasPositiveEstimatedRevenue = !!estimatedRevenue && estimatedRevenue > 0

  if (hasRevenue && hasPositiveEstimatedRevenue) {
    return (revenue / estimatedRevenue) * 100
  }

  return null
}
